export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10847.6c514d18.jpg";